// 最近会话页面
import React, { useEffect } from "react";

import { IItemData } from "./common.typing";

import PageTitle from "./PageTitle";
import CommonList from "./CommonList";

import locale from "../../_util/locale";

export interface RecentSessionProps {
    prePage: string;
    type?: string;
    onChangeCurPage: (page: string) => void;
    onChangePrePage: (page: string) => void;
    setCurrentGroupInfo: (group: { id: number | string; name: string }) => void;
    currentList: IItemData[];
    setCurrentList: (list: IItemData[]) => void;
    getRecentSessionList?: () => void;
    recentSessionList?: IItemData[];
    /** 不可用 id，包括 group、user、session、org */
    disabledids?: string[];

    requiredList?: IItemData[];
    multiple?: boolean;
}

const RecentSession: React.FC<RecentSessionProps> = ({
    prePage,
    type,
    onChangeCurPage,
    onChangePrePage,
    setCurrentGroupInfo,
    currentList,
    setCurrentList,
    recentSessionList,
    getRecentSessionList,
    disabledids,
    requiredList,
    multiple,
}) => {
    useEffect(() => {
        getRecentSessionList && getRecentSessionList();
    }, []);

    /**
     * pageTitle 返回
     * prePage: home
     */
    const onBack = () => {
        onChangeCurPage(prePage);
    };

    const onClickPartner = async (id: number | string, name: string) => {
        setCurrentGroupInfo({ id, name });
        onChangeCurPage("groupMember");
        onChangePrePage("recentSession");
    };

    return (
        <div className="recentSession">
            {/* <PageTitle
                {...{
                    title: locale("useradd_type_session"),
                    onBack,
                }}
            /> */}
            {type == "member" ? (
                    <CommonList
                        {...{
                            type: "combination",
                            list: recentSessionList,
                            currentList,
                            setCurrentList,
                            disabledids,
                            requiredList,
                            isShowOrg: true,
                        onClickPartner,
                    }}
                />
            ) : (
                <CommonList
                    {...{
                        type: "session",
                        list: recentSessionList,
                        currentList,
                        setCurrentList,
                        disabledids,
                        requiredList,
                        isShowOrg: true,
                        multiple,
                    }}
                />
            )}
        </div>
    );
};

export default RecentSession;
